import { SET_COURSES_PREFERENCES_STATE } from "./actionTypes";

// eslint-disable-next-line
export default (state = {}, action) => {
  switch (action.type) {
    case SET_COURSES_PREFERENCES_STATE:
      return action.payload;
    default:
      return state;
  }
};
